import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/dict-biz/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const queryTenantList = () => {
  return request({
    url: '/api/blade-system/tenant/select',
    method: 'get'
  })
}
export const getParentList = (current, size, params) => {
  return request({
    url: '/api/blade-system/dict-biz/parent-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getChildList = (current, size, parentId, params) => {
  return request({
    url: '/api/blade-system/dict-biz/child-list?tenantId=' + params.tenantId,
    method: 'get',
    params: {
      ...params,
      current,
      size,
      parentId: parentId,
    }
  })
}

export const remove = (ids, tenantId) => {
  return request({
    url: '/api/blade-system/dict-biz/remove?tenantId=' + tenantId,
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/dict-biz/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/dict-biz/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  })
}


export const getDict = (id, tenantId) => {
  return request({
    url: '/api/blade-system/dict-biz/detail?tenantId=' + tenantId,
    method: 'get',
    params: {
      id,
    }
  })
}
export const getDictTree = () => {
  return request({
    url: '/api/blade-system/dict-biz/tree?code=DICT',
    method: 'get'
  })
}

export const getDictionary = (params) => {
  return request({
    url: '/api/blade-system/dict-biz/dictionary',
    method: 'get',
    params,
  })
}
